import { Route, Routes } from "react-router-dom";

// all routes
import {
  Login,
  ForgetPassword,
  ResetPassword,
  Dashboard,
  Scoreboard,
  Register,
  Profile,
  EditProfile,
  ChangePassword,
  ChangeEmail,
  NotFound,
} from "../pages";
import UnprotectedRoute from "../pages/UnprotectedRoute";
import ProtectedRoute from "../pages/ProtectedRoute";

export const clientRoutes = {
  dashboard: "/",
  dashboardmain: "/dashboard",
  scoreboard: "/scoreboard",
  login: "/login",
  register: "/register",
  forgetPassword: "/forget-password",
  resetPassword: "/reset-password/:token",
  profile: "/profile",
  editprofile: "/edit-profile",
  changePassword: "/change-password",
  changeEmail: "/change-email",
};

const ClientRouter = () => {
  return (
    <Routes>
      <Route element={<UnprotectedRoute />}>
        <Route path={clientRoutes.register} element={<Register />} />
        <Route path={clientRoutes.login} element={<Login />} />
        <Route path={clientRoutes.resetPassword} element={<ResetPassword />} />
        <Route
          path={clientRoutes.forgetPassword}
          element={<ForgetPassword />}
        />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path={clientRoutes.dashboard} element={<Dashboard />} />
        <Route path={clientRoutes.dashboardmain} element={<Dashboard />} />
        <Route path={clientRoutes.scoreboard} element={<Scoreboard />} />
        <Route path={clientRoutes.profile} element={<Profile />} />
        <Route path={clientRoutes.editprofile} element={<EditProfile />} />
        <Route
          path={clientRoutes.changePassword}
          element={<ChangePassword />}
        />
        <Route path={clientRoutes.changeEmail} element={<ChangeEmail />} />
      </Route>
      {/* 404 Catch-all route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default ClientRouter;
